import { useParams } from 'react-router-dom';

export default function GamePlayPage() {
  const { gameCode } = useParams();
  
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="glass-container text-center max-w-2xl mx-auto">
        <h1 className="text-3xl font-display font-bold mb-4">
          Juego: {gameCode}
        </h1>
        <p className="text-white/70 mb-8">
          Esta página mostrará el juego seleccionado.
          <br />
          Por ahora es un placeholder.
        </p>
        <p className="text-sm text-white/50">
          🚧 En desarrollo - Próximamente disponible
        </p>
      </div>
    </div>
  );
}
